import { useEffect } from 'react'
import BlogSection from '../../components/BlogSection'
import BritFilerPage from '../../components/CanUse'
// import ContactSection from '../../components/Contact'
import DashboardSection from '../../components/DashboardSection'
import FAQSection from '../../components/FAQSection'
import FeaturesSection from '../../components/FeaturesSection'
import Footer from '../../components/Footer'
import HeroSection from '../../components/HeroSection'
import HowitWorks from '../../components/HowitWorks'
// import MediaLogosSection from '../../components/MediaLogosSection'
import PricingSection from '../../components/PricingSection'
import ServicesAtGlanceSection from '../../components/ServicesAtGlanceSection'
import TestimonialsSection from '../../components/TestimonialsSection'
import { loadTawkTo } from '../../utils/tawkService'

export default function LandingPage() {
  useEffect(() => {
    // Handle hash navigation on page load
    const hash = window.location.hash.replace('#', '')
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash)
        if (element) {
          const headerOffset = 80
          const elementPosition = element.getBoundingClientRect().top
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          })
        }
      }, 300) // Small delay to ensure page is loaded
    }
  }, [])

  // Initialize Tawk.to widget on landing page
  useEffect(() => {
    loadTawkTo().catch((error) => {
      console.error('Failed to load Tawk.to widget:', error)
    })
  }, [])

  return (
    <div className='min-h-screen bg-white relative overflow-hidden'>
      <div id='home'>
        <HeroSection />
      </div>
      <DashboardSection />
      <ServicesAtGlanceSection />
      <div id='features'>
        <FeaturesSection />
      </div>
      <HowitWorks />
      {/* <MediaLogosSection /> */}
      <TestimonialsSection />
      <BritFilerPage />
      <div id='pricing'>
        <PricingSection />
      </div>
      <div id='faq'>
        <FAQSection />
      </div>
      <div id='blog'>
        <BlogSection />
      </div>
      {/* Contact section hidden as requested */}
      {/* <div id='contact'>
        <ContactSection />
      </div> */}
      <Footer />
    </div>
  )
}